import { Box, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { ENTERPRISE_IMAGE_PATH, isEnterprise } from "../../theme";
import logo from "../../components/ResponsiveNavbar/logo.png";
import { Link } from "react-router-dom";
import { SelectEnterpriseProps } from "./types";
import { selectEnterpriseStyles } from "./styles";
import { EnterpriseType } from "../../contexts";
import { useEffect, useState } from "react";
import Loading from "../Loading";

export const SelectEnterprise: React.FC<SelectEnterpriseProps> = ({
  enterprises,
  allEnterprisesInfo,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    if (enterprises.length > 1) {
      setIsLoading(false);
    }
  }, [enterprises.length]);
  return (
    <>
      {!isLoading ? (
        <Box sx={selectEnterpriseStyles.mainContainer}>
          <Box>
            <Link to="/my-tracks">
              <img
                style={
                  isSmallScreen
                    ? { width: "40vw", height: "6vh" }
                    : { width: "20vw", height: "12vh" }
                }
                className="logo-image"
                src={isEnterprise ? ENTERPRISE_IMAGE_PATH : logo}
                alt="logo"
              />
            </Link>
            <Typography
              variant="h5"
              sx={{ textAlign: "center", fontWeight: "bold" }}
            >
              Select enterprise
            </Typography>
          </Box>
          <Box sx={selectEnterpriseStyles.gridContainer}>
            {enterprises.map((enterprise, i) => {
              const matchingEnterprise = allEnterprisesInfo.find(
                (ent) => ent.getId() === enterprise.getEnterpriseId()
              );
              return (
                <Box
                  onClick={() => {
                    const newEnterprise: EnterpriseType = {
                      id: enterprise.getEnterpriseId(),
                      name: enterprise.getEnterpriseName(),
                      image: matchingEnterprise?.getImage() ?? "",
                      role: enterprise.getRole(),
                      storageLimit: matchingEnterprise?.getStorageLimit() ?? 0,
                      masteringCount:
                        matchingEnterprise?.getMasteringCount() ?? 0,
                    };
                    sessionStorage.setItem(
                      "enterprise",
                      JSON.stringify(newEnterprise)
                    );
                    window.location.href = "/my-tracks";
                  }}
                  key={i}
                  sx={selectEnterpriseStyles.enterpriseCard}
                >
                  <Typography
                    variant="h6"
                    sx={selectEnterpriseStyles.typography}
                  >
                    {enterprise.getEnterpriseName().length > 18 ? (
                      <Tooltip
                        title={
                          enterprise.getEnterpriseName() === "ommuse"
                            ? "Personal"
                            : enterprise.getEnterpriseName()
                        }
                        placement="top-start"
                      >
                        <span>
                          {enterprise.getEnterpriseName() === "ommuse"
                            ? "Personal"
                            : enterprise.getEnterpriseName()}
                        </span>
                      </Tooltip>
                    ) : enterprise.getEnterpriseName() === "ommuse" ? (
                      "Personal"
                    ) : (
                      enterprise.getEnterpriseName()
                    )}
                  </Typography>
                  <img
                    style={selectEnterpriseStyles.enterpriseImage}
                    src={
                      matchingEnterprise?.getImage().includes("http")
                        ? matchingEnterprise?.getImage()
                        : "/assets/images/logo512.png"
                    }
                    alt="ent-img"
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      ) : (
        <Loading />
      )}
    </>
  );
};
